<template lang="pug">
    div.weaponModContent(v-if="weaponModItem && JSON.stringify(weaponModItem)!=='{}'")
        div.weapnHeadBox
            div.weaponIconBox
                div.weaponIcon
                    img(alt="", :src="require('../assets/weapon_icon/'+weaponModItem.weponIcon)")
            div.arrow
            div.weaponModIconBox
                div.weaponModIcon
                    img(alt="", :src="require('../assets/weapon_mod_icon/'+weaponModItem.weaponModIcon)")
        div.weaponModName {{weaponModItem.weaponModName}}
        div.weaponModInfoBox
            div.content
                span.contentTitle {{$t("weaponModContent.weaponModInfoBox")}}
                div#weaponModInfo
                    div(v-for="(item, index) in weaponModItem.weaponModInfo", :key="index", class="weaponModInfoItem")
                        div#weaponModLevel
                            img(alt="", :src="require('../assets/level'+weaponModItem.weaponModInfo[index].level+'.png')")
                        div#weaponModRight
                            div(v-if="weaponModItem.weaponModInfo[index].atk != '' && weaponModItem.weaponModInfo[index].atk != '-' && weaponModItem.weaponModInfo[index].atk != '0'") ATK+{{weaponModItem.weaponModInfo[index].atk}}
                            div(v-if="weaponModItem.weaponModInfo[index].describe != '' && weaponModItem.weaponModInfo[index].describe != '-' && weaponModItem.weaponModInfo[index].describe != '0'") 
                                img(alt="", :src="require('../assets/weapon_mod_skill_icon/'+weaponModItem.weaponModInfo[index].describeSkillIcon)")
                                span {{weaponModItem.weaponModInfo[index].describe}}
</template>
  
<script>
export default {
    name: 'WeaponModContent',
    data() {
        return {
            weaponModId:"",
            weaponModItem:{},
            weaponModItemList:[]
        }
    },
    created() {
        
    },
    methods:{        
        retrieveData(){
            for(let i = 0; i < this.weaponModItemList.length; i++){
                if(this.weaponModItemList[i].weaponModId == this.weaponModId){
                    this.weaponModItem = this.$t("weaponModItemList["+i+"]")
                }
            }
        }
    },
    components:{

    },
    mounted() {
        let wikiData = require("../assets/lang/zh_CN.json")
        this.weaponModItemList = wikiData.weaponModItemList
        this.weaponModId = this.$route.params.id
        this.$nextTick(() => {
            this.retrieveData()
        })
    }
}
</script>

<style lang="scss">
#app{
    background-color: #1c1f1f;
    background: url("../assets/foot_bg.png") center bottom no-repeat;
    background-size: contain;
}
.weaponModContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    background: url("../assets/weapon_icon_bg.png") center top no-repeat;
    background-size: contain;
    .weapnHeadBox {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }
    .weaponIconBox {
        position: relative;
        left: -120px;
        top: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 108.3px;
        height: 143.64px;
        background: url("../assets/weapon_icon_box_bg.png") center center no-repeat;
        background-size: contain;
    }
    .weaponIcon {
        width: 70.96px;
        height: 92.94px;
    }
    .weaponIcon img {
        width: 100%;
        height: 100%;
    }
    .arrow {
        position: relative;
        left: -26px;
        top: -33px;
        width: 56.62px;
        height: 21.84px;
        background: url("../assets/arrow.png") center center no-repeat;
        background-size: contain;
    }
    .weaponModIconBox {
        position: relative;
        left: 94px;
        top: -156px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 159.6px;
        height: 235.62px;
        background: url("../assets/weapon_mod_list_icon_bg.png") center center no-repeat;
        background-size: contain;
    }
    .weaponModIcon {
        width: 128.66px;
        height: 158.7px;
    }
    .weaponModIcon img {
        width: 100%;
        height: 100%;
    }
    .weaponModName {
        margin-top: -120px;
        width: 90%;
        font-size: 32px;
        font-weight: bold;
        color: #dceae3;
        padding: 0 5%;
    }
    .weaponModInfoBox {
        margin: 22px 0;
        width: 90%;
        color: #dceae3;
    }
    .content {
        float: left;
        width: 100%;
        min-height: 124px;
        background: url("../assets/content_bg.png") top center no-repeat;
        background-size: contain;
        background-color: rgba(0,0,0,0.7);
        border: 1px #212322 solid;
    }
    .contentTitle {
        float: left;
        margin: 15px 0;
        padding-left: 8%;
        width: 92%;
        font-size: 20px;
        line-height: 18px;
        background: url("../assets/title_icon.png") 5% center no-repeat;
        background-size: contain;
    }
    .weaponModInfoItem {
        float: left;
        position: relative;
        margin: 0 0 0 5%;
        width: 90%;
        border-top: 2px #262a27 solid;
    }
    .weaponModInfoItem:last-child {
        margin-bottom: 20px;
        border-bottom: 2px #262a27 solid;
    }
    #weaponModLevel {
        float: left;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 30%;
        font-size: 14px;
        text-align: left;
        color: #dceae3;
    }
    #weaponModLevel img {
        width: 90%;
        justify-content: center;
        align-items: center;
        border: none;
        display: flex;
    }
    #weaponModRight {
        float: right;
        margin: 0;
        width: 69%;
        border-left: 1px #262a27 solid;
        border-top: none;
        font-size: 14px;
        text-align: left;
        color: #dceae3;
    }
    #weaponModRight div {
        display: flex;
        //justify-content: center;
        align-items: center;
        padding: 5px 10px;
        border-bottom: 1px #262a27 solid;
    }
    #weaponModRight div:last-child {
        border-bottom: 0;
    }
    #weaponModRight div img {
        padding-right: 10px;
        width: 37.28px;
    }
}
</style>